// src/components/BusinessRegSteps/Step1BasicInfo.js
import React from 'react';
import { BuildingOfficeIcon, TagIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const Step1BasicInfo = ({ formData, updateFormData }) => {
    const businessTypes = [
        { value: '', label: 'Select Business Type' },
        { value: 'sole_proprietor', label: 'Sole Proprietor' },
        { value: 'llc', label: 'Limited Liability Company (LLC)' },
        { value: 'pty_ltd', label: 'Proprietary Limited (Pty) Ltd' }, // Common in SA
        { value: 'partnership', label: 'Partnership' },
        { value: 'non_profit', label: 'Non-Profit Organization' },
        { value: 'other', label: 'Other' },
    ];

    const industries = [
        { value: '', label: 'Select your industry (Optional)' },
        { value: 'retail', label: 'Retail' },
        { value: 'food_beverage', label: 'Food & Beverage' },
        { value: 'beauty_salon', label: 'Beauty & Salon' },
        { value: 'ecommerce', label: 'E-commerce' },
        { value: 'services', label: 'Services' },
        { value: 'health_wellness', label: 'Health & Wellness' },
        { value: 'automotive', label: 'Automotive' },
        { value: 'entertainment', label: 'Entertainment' },
        { value: 'hospitality', label: 'Hospitality' },
        { value: 'education', label: 'Education' },
        { value: 'manufacturing', label: 'Manufacturing' },
        { value: 'technology', label: 'Technology' },
        { value: 'real_estate', label: 'Real Estate' },
        { value: 'other', label: 'Other' },
    ];

    return (
        <fieldset className="border p-4 rounded-md space-y-4">
            <legend className="text-lg font-medium text-gray-900 flex items-center">
                <BuildingOfficeIcon className="h-6 w-6 text-indigo-500 mr-2" />
                Step 1: Basic Business Information
            </legend>

            {/* Business Name */}
            <div>
                <label htmlFor="business-name" className="block text-sm font-medium text-gray-700">Business Name (Legal)</label>
                <div className="relative mt-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <BuildingOfficeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <input
                        id="business-name"
                        name="business-name"
                        type="text"
                        required
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="e.g., My Awesome Shop (Pty) Ltd"
                        value={formData.businessName}
                        onChange={(e) => updateFormData('businessName', e.target.value)}
                    />
                </div>
            </div>

            {/* Business Type */}
            <div>
                <label htmlFor="business-type" className="block text-sm font-medium text-gray-700">Business Type</label>
                <div className="relative mt-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <QuestionMarkCircleIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <select
                        id="business-type"
                        name="business-type"
                        required
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white"
                        value={formData.businessType}
                        onChange={(e) => updateFormData('businessType', e.target.value)}
                    >
                        {businessTypes.map((type) => (
                            <option key={type.value} value={type.value}>
                                {type.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Industry */}
            <div>
                <label htmlFor="industry" className="block text-sm font-medium text-gray-700">Industry (Optional)</label>
                <div className="relative mt-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <TagIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <select
                        id="industry"
                        name="industry"
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white"
                        value={formData.industry}
                        onChange={(e) => updateFormData('industry', e.target.value)}
                    >
                        {industries.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </fieldset>
    );
};

export default Step1BasicInfo;